// extracted by css-extract-rspack-plugin
export default {"starButton":"SpacesSelectionMenu-module__starButton__jfA3O"};